import React from 'react';
import SearchFilterWidget from "../../../widget/searchProducts/SearchFilterWidget";
import {ProductList} from "../../../features/productSearch";
import ProductLoadMore from "../../../features/productSearch/ui/products/ProductLoadMore";
import styled from "styled-components";
import {ToggleCartButton} from "../../../features/goods/toggle-goods-to-cart";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledWidget = styled.div`
    padding-bottom: 50px;
`
/**
 *  Составной (composed) виджет для хост-приложения в режиме Modal, включающий компоненты:
 *   SuggestionList - подсказки
 *   SearchFilterWidget - фильтр
 *   ProductList - результат поиска
 *   ProductLoadMore - кнопка/механизм подгрузки дополнительных товаров
 *
 * @returns {JSX.Element} -
 */
const ModalProductSearchWidget = () => {
    return (
        <StyledWidget onClick={(e: any) => e.stopPropagation()}
                      className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('content')}`}
        >
            <SearchFilterWidget/>
            <ProductList ToggleToCartButtonSlot={ToggleCartButton}/>
            <ProductLoadMore/>
        </StyledWidget>
    );
};

export default ModalProductSearchWidget;